export enum ChartDataType {
  DEALER_CHART = 'dealerChart',
  SECTOR_CHART = 'sectorChart',
}

export enum ChartsGrouping {
  VOLUME = 'volume',
  COUNT = 'count',
}

export enum SectorGrouping {
  SECTOR = 'sector',
  SUB_SECTOR = 'subsector',
}

export enum ChartType {
  GROUPED = 'grouped',
  STACKED = 'staked',
}

export const ALL_OTHERS_NAME = 'All Others';
export const ALL_OTHERS_COLOR = '#989898';

export const INIT_TOOLTIP_DATA = {
  name: ALL_OTHERS_NAME,
  color: ALL_OTHERS_COLOR,
  x: 0,
  y: 0,
  dealCount: 0,
  dealSize: 0,
  percentage: 0,
};
